document.addEventListener("DOMContentLoaded", function () {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    function displayWishlist() {
        let wishlistContainer = document.getElementById("wishlist-items");
        if (!wishlistContainer) return; // Prevents errors if the element is missing
        wishlistContainer.innerHTML = "";

        if (wishlist.length === 0) {
            wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
            return;
        }

        wishlist.forEach(item => {
            let listItem = document.createElement("li");
            listItem.classList.add("wishlist-item");
            listItem.innerHTML = `
                <img src="${item.image}" class="wishlist-image">
                <p class="wishlist-product-title">${item.title}</p>
                <div class="wishlist-buttons">
                    <a href="${item.url}" class="view-product-btn">👁️ View Product</a>
                    <button class="move-to-cart-btn" data-product-id="${item.id}">🛍️ ADD TO CART </button>
                    <button class="delete-wishlist-btn" data-product-id="${item.id}">❌ Remove from Wishlist</button>
                </div>
            `;
            wishlistContainer.appendChild(listItem);
        });

        // Attach event listeners for "Remove from Wishlist" buttons
        document.querySelectorAll(".delete-wishlist-btn").forEach(button => {
            button.addEventListener("click", function () {
                let productId = this.getAttribute("data-product-id");
                wishlist = wishlist.filter(item => item.id !== productId);
                localStorage.setItem("wishlist", JSON.stringify(wishlist));
                displayWishlist();
            });
        });

        // Attach event listeners for "Move to Cart" buttons
        document.querySelectorAll(".move-to-cart-btn").forEach(button => {
            button.addEventListener("click", function () {
                let productId = this.getAttribute("data-product-id");
                addToCart(productId);
                wishlist = wishlist.filter(item => item.id !== productId);
                localStorage.setItem("wishlist", JSON.stringify(wishlist));
                displayWishlist();
            });
        });
    }

    function addToWishlist(event) {
        event.preventDefault();

        let productId = event.target.getAttribute("data-product-id");
        let productTitle = event.target.getAttribute("data-product-title");
        let productImage = document.querySelector(".product__media img") 
            ? document.querySelector(".product__media img").src 
            : "";
        let productUrl = window.location.href;

        if (!productId) {
            alert("Error: Unable to add product to wishlist.");
            return;
        }

        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        // Remove duplicate items before adding a new one
        wishlist = wishlist.filter(item => item.id !== productId);

        wishlist.push({
            id: productId,
            title: productTitle,
            image: productImage,
            url: productUrl
        });

        localStorage.setItem("wishlist", JSON.stringify(wishlist));
        
        // Show pop-up notification
        showWishlistPopup();

        displayWishlist();
    }

 function addToCart(productId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: productId })
    })
    .then(() => {
        showCartPopup(); // ✅ Call the new cart pop-up function
    });
}


    function showWishlistPopup() {
        let popup = document.createElement("div");
        popup.className = "wishlist-popup";
        popup.innerHTML = "✅ Item added to your wishlist!";
        document.body.appendChild(popup);

        setTimeout(() => {
            popup.style.opacity = "0"; // Fade out effect
            setTimeout(() => popup.remove(), 500); // Remove from DOM after fading out
        }, 2000); // Auto-close after 2 seconds
    }

    // Ensure "Add to Wishlist" buttons work properly using event delegation
 document.addEventListener("click", function (event) {
    if (event.target.classList.contains("wishlist-btn")) {
        console.log("Wishlist button clicked!"); // Debugging line
        addToWishlist(event);
    }
});


    displayWishlist();
});
function showCartPopup() {
    let popup = document.createElement("div");
    popup.className = "cart-popup";
    popup.innerHTML = "🛒 Item moved to cart!";
    document.body.appendChild(popup);

    setTimeout(() => {
        popup.style.opacity = "0"; // Fade out effect
        setTimeout(() => popup.remove(), 500); // Remove from DOM after fading out
    }, 2000); // Auto-close after 2 seconds
}
